import React from 'react'
import * as PropTypes from 'prop-types'
import { Container, Row, Col } from '@headtrip/components-react'

import defaultHeader from '../../../images/background-image.jpg'

class Header extends React.Component {
  getBackgroundImage () {
    return this.props.headerImage || defaultHeader
  }

  // TODO no breadcrumbs needed as they clutter the navigation structure
  /*
    renderBreadcrumbs () {
      let currentLocation = this.props.location.pathname
      if (currentLocation === '/') return
      let pathEntries = currentLocation.split(path.sep)
      return pathEntries.map((site, index) => {
        let breadcrumbs = []

        let siteData = data.find((obj) => {
          console.log(obj, currentLocation)
        return obj.to === currentLocation
        })
        console.log(siteData)
        //site = site === '' ? 'Startseite' : site
        if (currentLocation.split(path.sep).pop() === site) {
          breadcrumbs.push(<li>{siteData.text}</li>)
        } else {
          breadcrumbs.push(<li><Link isUnstyled={true} to={siteData.to}>{siteData.text}</Link></li>)
        }

        index < pathEntries.length - 1 ? breadcrumbs.push(<li><i className="fa fa-angle-right">&nbsp;</i></li>) : null

        return breadcrumbs
      })
    } */

  // TODO refactor method if still needed
  // get the text link to github stored in data/site-data.json and return a link element
  // ignore the index.js cause there is no shared hetzner github repository
  /* renderGithubLink () {
    let currentLocation = this.props.location.pathname
    let githubLink = this.props.data.edges.map(edge => {
      let site = edge.node.site.find(entry => {
        return currentLocation !== '/' && currentLocation.includes(entry.basePath) && currentLocation === entry.path
      })
      if (typeof site !== 'undefined') {
        return site.linkToGithub
      }
    })
    return typeof githubLink[0] !== 'undefined' &&
      <a className="btn btn-white-light link-header-github" href={githubLink} target="_blank">Visit us on
        Github</a>
  } */

  // methods returns first level of navigation as array e.g. /cloud/libraries => /cloud
  // to detect the current plattform

  // each plattform shares the same header with their subsites therfore they need a shared header
  // this method returns the shared headername

  render () {
    const className = this.props.className || ''
    return (
      <section className={`background-header ${className}`} style={{ backgroundImage: `url(${this.getBackgroundImage()})` }}>
        <img className='header-icon d-none d-xl-block' src={this.props.headerIcon} alt='' />
        {this.props.children ? this.props.children : (
          <Container>
            <div className='mx-auto mb-4' style={{ maxWidth: '45rem' }}>
              <a href='https://github.com/hetzneronline/community-content'>
                <span className='text-center badge badge-pill badge-blue font-size-small' style={{ padding: '.5rem 1.25rem' }}>
                  <strong>Get Rewarded:</strong> We will give you up to <strong>€50</strong> credit on your account for every tutorial you write and we publish
                </span>
              </a>
            </div>
            <Row>
              <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                <ul className='list-unstyled list-headlines'>
                  <li><h1>Hetzner {this.props.headerName} Developer Hub</h1></li>
                  <li>Everything developers need</li>
                  <li>Learn, share, grow.</li>
                </ul>
              </Col>
            </Row>
          </Container>
        )}
      </section>
    )
  }
}

export default Header

Header.propTypes = {
  headerName: PropTypes.string,
  headerIcon: PropTypes.string,
  backgroundImage: PropTypes.string
}
